import React, {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import DeliveryListIcon from "../../../../public/images/delivery-list-icon.svg";
import MapIcon from "../../../../public/images/map-icon.svg";
import ManuelDeliveryIcon from "../../../../public/images/manuel-delivery-icon.svg";
import {
    CustomTab,
    CustomTabRow,
    ManuelDeliveryButton,
    SectionIcon,
    SectionTab,
    SectionTabButton,
    SectionTabRow,
    TableCell,
    Wrapper
} from "./DeliveryListBlock.styles";
import {FileSearchOutlined} from "@ant-design/icons";
import {Button, Col, Row, Table} from "antd";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import useIsFocused from "../../../../hooks/useIsFocused";
import {ConditionalTooltip} from "../../../_defaultComponents/ConditionalTooltip/ConditionalTooltip";
import {getConstant, isConstantExist, truncateString} from "../../../../utils/helpers";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {deliveryStatuses} from "../../../../constants/constants";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {ReceiptPrinter} from "../../../_defaultComponents/ReceiptPrinter/ReceiptPrinter";
import {CustomerApplyButton} from "../../customerOrdersPage/customerApplyButton/CustomerApplyButton";
import {CustomerMap} from "../../../customerMap/CustomerMap";
import SplitOrderButton from "components/customer/customerSplitOrderButton/splitOrderButton";
import {TableWrapper} from "../../../_defaultComponents/TableWrapper/TableWrapper";
import {CustomerOrderDetailModal} from "components/customer/customerOrdersPage/customerOrdersTable/customerOrderDetailModal/CustomerOrderDetailModal";
import {QueueModal} from "components/customer/customerOrdersPage/customerOrdersTable/queueModal/QueueModal";
import {TextBoxFormModal} from "../../../_defaultComponents/TextBoxFormModal/TextBoxFormModal.js";
import {IntegrationsTab} from "./components/IntegrationsTab";
import IntegrationsIcon from "../../../../public/images/integrations.svg";

const RELOAD_INTERVAL = 1000 * 10; //10 seconds

export const DeliveryListBlock = ({activeIntegrationUrls}) => {
    const stores = useStore();
    const history = useHistory();
    const {t, i18n} = useTranslation(["deliveryStatuses", "orderDetail"]);
    const [orderType, setOrderType] = useState("current");
    const [activeTab, setActiveTab] = useState("orders"); // "orders" or "map"
    const isMobile = window.innerWidth < 768;
    const [receiptModalVisible, setReceiptModalVisible] = useState(false);
    const [isReceiptPrinting, setIsReceiptPrinting] = useState(false);
    const receiptRef = useRef();
    const isFocused = useIsFocused();
    const [recall, setRecall] = useState(true);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderDate, setOrderDate] = useState(null);
    const recallRef = useRef(recall);
    recallRef.current = recall;
    const [deliveryId, setDeliveryId] = useState("");
    const [customerOrderDetailModalVisible, setCustomerOrderDetailModalVisible] = useState(false);
    const [queueModalVisible, setQueueModalVisible] = useState(false);
    const [queueModalData, setQueueModalData] = useState(null);
    const [queueModalIndex, setQueueModalIndex] = useState(0);
    const [preferredCourierValue, setPreferredCourierValue] = useState(null);
    const [forceCourierValue, setForceCourierValue] = useState(null);
    const [availableCouriers, setAvailableCouriers] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState("");
    const [submit, setSubmit] = useState();
    const [text, setText] = useState({});
    const [modalData, setModalData] = useState({
        deliveryId: "",
        orderId: ""
    });
    const selectedSubCompanyId = stores.meStore.selectedSubCompanyId;
    const selectedSubCompanies = React.useMemo(() => {
        return selectedSubCompanyId ? [selectedSubCompanyId] : [];
    }, [selectedSubCompanyId]);

    const nullObjectCheck = obj => {
        return JSON.stringify(obj) === JSON.stringify({});
    };

    const [loading, orderList, _, __] = useFetch({
        fetchFn: stores.orderStore.getOrderList.bind(null, {
            limit: 3,
            skip: 0,
            sortField: {field: "", asc: true},
            companies: [],
            subcompanies: selectedSubCompanies,
            deliveryStatus: orderType,
            deliveryStatusOverrides: [],
            searchText: ""
        }),
        defaultDataValue: [],
        initialCall: false,
        dependencies: [recall, orderType, selectedSubCompanyId]
    });

    useEffect(() => {
        setTimeout(() => {
            setRecall(!recallRef.current);
        }, 200);
    }, []);

    useEffect(() => {
        if (isFocused) {
            let timeout = null;

            timeout = setTimeout(() => {
                setRecall(!recallRef.current);
            }, RELOAD_INTERVAL);

            return () => clearTimeout(timeout);
        }
    }, [recall, isFocused]);

    const columns = [
        {
            title: "Sipariş No",
            dataIndex: "orderNumbers",
            render: (orderNumbers, record, index) => (
                <TableCell>
                    <ConditionalTooltip
                        condition={true}
                        text={orderNumbers}
                        child={
                            <a
                                onClick={() => {
                                    if (orderType === "inQueue") {
                                        setQueueModalIndex(index);
                                        displayQueueModal();
                                    } else {
                                        setDeliveryId(record.deliveryId);
                                        setCustomerOrderDetailModalVisible(true);
                                    }
                                }}
                            >
                                {truncateString(orderNumbers, 16)}
                            </a>
                        }
                    />
                </TableCell>
            )
        },
        {
            title: "Tarih",
            dataIndex: "createdAt",
            render: text => <TableCell>{text}</TableCell>,
            responsive: ["md"]
        },
        {
            title: "Şube",
            dataIndex: "subcompanies",
            render: subcompanies => (
                <TableCell>
                    <ConditionalTooltip
                        condition={true}
                        text={subcompanies}
                        child={
                            <div
                                data-testid="subcompanies"
                                style={{maxWidth: "100%", wordBreak: "break-word"}}
                            >
                                {truncateString(subcompanies, 40)}
                            </div>
                        }
                    />
                </TableCell>
            ),
            responsive: ["lg"]
        },
        {
            title: "Müşteri İsmi / Fiş Numarası",
            dataIndex: "customers",
            render: (customers, record) => (
                <TableCell>
                    <ConditionalTooltip
                        condition={true}
                        text={customers}
                        child={
                            <div
                                data-testid="customers"
                                style={{maxWidth: "100%", wordBreak: "break-word"}}
                            >
                                {truncateString(
                                    record?.orders?.some(order => order?.receiptNumber)
                                        ? record?.orders?.find(order => order?.receiptNumber)
                                              ?.receiptNumber
                                        : record?.orders?.find(order => order?.receiverName)
                                              ?.receiverName,
                                    20
                                )}
                            </div>
                        }
                    />
                </TableCell>
            )
        },
        {
            title: "Seçilen Kurye",
            dataIndex: "requestedBy",
            render: (_, record) => (
                <div>
                    {record.requestedBy ? (
                        <CustomerApplyButton
                            setRecall={setRecall}
                            deliveryId={record._id}
                            courierName={record.requestedBy.fullname}
                            courierId={record.requestedBy._id}
                        />
                    ) : (
                        "-"
                    )}
                </div>
            )
        },
        {
            title: "Kurye",
            dataIndex: "courier",
            render: text => <TableCell>{text}</TableCell>,
            responsive: ["lg"]
        },
        {
            title: "Durum",
            dataIndex: "summary",
            render: (text, delivery) => (
                <TableCell>{renderActiveDeliveryStatusText(delivery)}</TableCell>
            )
        },
        ...(orderList?.rows?.some(row => row.integrationType === "dedicatedIntegration") &&
        orderType === "current" &&
        stores.meStore.checkRole("canSplitDeliveries")
            ? [
                  {
                      title: "Siparişi Ayır",
                      render: (text, delivery) => {
                          if (delivery.integrationType !== "dedicatedIntegration") {
                              return "-";
                          }
                          return (
                              <SplitOrderButton
                                  deliveryId={delivery._id}
                                  delivery={delivery}
                                  deliveryType={delivery.deliveryType}
                                  orders={delivery.orders}
                                  reasonOptions={{
                                      defaultValue: "cancelDueToCompany"
                                  }}
                                  onSplitComplete={() => {
                                      setRecall(!recallRef.current);
                                  }}
                              />
                          );
                      }
                  }
              ]
            : []),
        {
            title: "Detay",
            dataIndex: "detail",
            render: (text, delivery) => {
                const orders = delivery?.orders || [];
                const order = orders?.length === 1 ? orders[0] : null;

                return (
                    <>
                        <TableCell>
                            <Row gutter={[8, 8]} align="middle" justify="center">
                                {order ? (
                                    <Col>
                                        <Button
                                            type="primary"
                                            size="middle"
                                            style={{
                                                height: "32px",
                                                fontSize: "14px",
                                                borderRadius: "4px",
                                                backgroundColor: "#AEF001",
                                                border: "none",
                                                color: "#000"
                                            }}
                                            onClick={() => {
                                                setSelectedOrder(order);
                                                setOrderDate(delivery?.createdAt);
                                                setReceiptModalVisible(true);
                                            }}
                                        >
                                            Fişi görüntüle
                                        </Button>
                                    </Col>
                                ) : null}
                                <Col>
                                    <CustomButton
                                        onClick={() => {
                                            if (orderType === "inQueue") {
                                                const deliveryIndex = orderList?.rows?.findIndex(
                                                    row => row._id === delivery._id
                                                );
                                                setQueueModalIndex(
                                                    deliveryIndex >= 0 ? deliveryIndex : 0
                                                );
                                                displayQueueModal();
                                            } else {
                                                setDeliveryId(delivery?.deliveryId);
                                                setCustomerOrderDetailModalVisible(true);
                                            }
                                        }}
                                        icon={<FileSearchOutlined />}
                                    />
                                </Col>
                            </Row>
                        </TableCell>
                        <ReceiptPrinter
                            receiptModalVisible={receiptModalVisible}
                            setReceiptModalVisible={setReceiptModalVisible}
                            order={selectedOrder}
                            receiptRef={receiptRef}
                            setIsReceiptPrinting={setIsReceiptPrinting}
                            isReceiptPrinting={isReceiptPrinting}
                            customerCreatedAt={orderDate}
                        />
                    </>
                );
            }
        }
    ];

    const deliveriesMapper = () => {
        if (
            !orderList ||
            nullObjectCheck(orderList) ||
            !Array.isArray(orderList.rows) ||
            orderList?.length === 0
        ) {
            return [];
        }
        const deliveries =
            orderList?.rows?.map((delivery, index) => {
                const orderNumbers = mapOrderNumbers({delivery});
                const subcompanies = mapSubCompany({delivery});
                const customers = delivery.orders.map(order => order.receiverName).join(", ");
                const courier = delivery?.assignedCourier?.fullname || "";
                return {
                    ...delivery,
                    deliveryId: delivery._id,
                    orderNumbers,
                    createdAt: delivery?.createdAt
                        ? moment(delivery.createdAt).format("DD.MM.YYYY HH:mm")
                        : "",
                    subcompanies,
                    customers,
                    courier,
                    status: delivery.status,
                    summary: delivery.summary,
                    requestedBy: delivery.requestedBy
                };
            }) || [];

        return deliveries;
    };

    const mapOrderNumbers = ({delivery}) => {
        let orderNumbers = delivery.orders.map(x => x.orderNumber).join(", ");
        if (delivery.orders.length > 1) {
            orderNumbers = delivery.orders.some(order => order?.orderNumber)
                ? delivery.orders
                      .filter(order => {
                          if (stores.meStore.checkRole("isCompanyUser")) {
                              return (
                                  stores.meStore.auth.companies.includes(
                                      order?.pickupInfoCompanyId?.toString()
                                  ) ||
                                  stores.meStore.auth.subcompanies.includes(
                                      order?.pickupInfoId?.toString()
                                  )
                              );
                          }
                          return true;
                      })
                      .map(order => order?.orderNumber)
                      .join(", ")
                : orderNumbers;
        }
        return orderNumbers;
    };

    const mapSubCompany = ({delivery}) => {
        let subCompanyName = delivery.pickupInfos[0].name;
        if (delivery.orders.length > 1) {
            subCompanyName = delivery.orders.some(order => order?.pickupInfoName)
                ? delivery.orders
                      .filter(order => {
                          if (stores.meStore.checkRole("isCompanyUser")) {
                              return (
                                  stores.meStore.auth.companies.includes(
                                      order?.pickupInfoCompanyId?.toString()
                                  ) ||
                                  stores.meStore.auth.subcompanies.includes(
                                      order?.pickupInfoId?.toString()
                                  )
                              );
                          }
                          return true;
                      })
                      .map(order => order?.pickupInfoName)
                      .join(", ")
                : subCompanyName;
        }
        return subCompanyName;
    };

    const calculateMultiOrderStats = delivery => {
        let totalOrdersCount = delivery?.orders?.length || 0;
        let deliveredOrdersCount = 0;
        let pickedUpOrdersCount = 0;
        if (["current", "burningOrders"].includes("current") && delivery?.orders.length > 1) {
            delivery?.orders?.forEach(order => {
                const hasPickedUp = delivery?.pickupInfos?.some(
                    pI =>
                        pI._id.toString() === order.pickupInfoId.toString() && pI.state === "picked"
                );
                if (hasPickedUp) {
                    pickedUpOrdersCount++;
                }

                if (order.state === "delivered") {
                    deliveredOrdersCount++;
                }
            });
        }
        return {
            totalOrdersCount,
            deliveredOrdersCount,
            pickedUpOrdersCount
        };
    };
    const renderActiveDeliveryStatusText = delivery => {
        let content = "-";

        const {
            totalOrdersCount,
            deliveredOrdersCount,
            pickedUpOrdersCount
        } = calculateMultiOrderStats(delivery);

        if (pickedUpOrdersCount > 0 || deliveredOrdersCount > 0) {
            content = (() => (
                <>
                    {t("mergedOrdersStatus.picked", {
                        ns: "orderDetail",
                        pickedUpCount: pickedUpOrdersCount,
                        totalCount: totalOrdersCount
                    })}
                    ,
                    <br />
                    {t("mergedOrdersStatus.delivered", {
                        ns: "orderDetail",
                        deliveredCount: deliveredOrdersCount,
                        totalCount: totalOrdersCount
                    })}
                </>
            ))();
        } else if (
            delivery.deliveryType === "productReturn" &&
            delivery.deliveryState === "returned"
        ) {
            content = t("delivered.name", {ns: "deliveryStatuses"});
        } else if (delivery.deliveryState === "onDeliveryAddress") {
            const endDate = delivery?.steps?.slice(-1)[0]?.endDate;
            const stepIndex =
                endDate && ["delivered", "returned"].includes(delivery?.deliveryState)
                    ? delivery.currentStepIndex + 1
                    : delivery.currentStepIndex - 1;

            const currentStep = delivery.steps[stepIndex];

            if (Boolean(currentStep.trial?.startDate) && !Boolean(currentStep.trial?.endDate)) {
                content = t("onTrial.name", {ns: "deliveryStatuses"});
            } else {
                content = t(
                    `${getConstant(deliveryStatuses, delivery.deliveryState).translation_key}.name`,
                    {
                        ns: "deliveryStatuses"
                    }
                );
            }
        } else if (delivery.deliveryState === "canceled" && delivery.merged == true) {
            content = t("mergedWithAnotherDelivery", {ns: "orderDetail"});
            if (delivery.mergedAt) {
                const deliveryLink = (
                    <a data-testid="mergedDeliveryLink" href={`/orders/${delivery.mergedAt}`} />
                );

                content = (
                    <Trans
                        i18nKey={"mergedDeliveryInfo"}
                        t={t}
                        ns="orderDetail"
                        components={{mergedDeliveryLink: deliveryLink}}
                    />
                );
            }
        } else if (isConstantExist(deliveryStatuses, delivery.deliveryState)) {
            content = t(
                `${getConstant(deliveryStatuses, delivery.deliveryState).translation_key}.name`,
                {
                    ns: "deliveryStatuses"
                }
            );
        }
        return <div data-testid="deliveryStatuses">{content}</div>;
    };

    const changeOrderType = orderType => {
        setOrderType(orderType);
    };

    const getAvailableCouriers = async (subCompanyId, courierType) => {
        const availableCouriers = await stores.courierStore.getAvailableCouriersForPreferredCourier(
            {
                subCompanyId,
                courierType,
                allPoolCouriers: true
            },
            false
        );
        setAvailableCouriers(availableCouriers);
    };

    const displayQueueModal = () => {
        setQueueModalData(orderList?.rows[queueModalIndex]);
        setPreferredCourierValue(null);
        setQueueModalVisible(true);
        if (orderList?.rows[queueModalIndex]?.pickupInfos?.[0]?._id) {
            getAvailableCouriers(
                orderList?.rows[queueModalIndex]?.pickupInfos[0]._id,
                orderList?.rows[queueModalIndex].courierType
            );
        }
    };

    const cancelDelivery = ({type, reason}) => {
        stores.appStore.openConfirmModal({
            title: t("modal.confirmTitle", {ns: "common"}),
            content: t("deliveryModal.cancelConfirmContent", {
                ns: "common"
            }),
            onOk: () => {
                stores.orderStore.cancelDelivery({
                    cancelText: reason.label,
                    cancelKey: reason.value,
                    deliveryId: queueModalData?._id
                });
                setRecall(!recallRef.current);
                setModalVisible(false);
                setQueueModalVisible(false);
                setPreferredCourierValue(null);
                setAvailableCouriers(null);
                setModalData({deliveryId: "", orderId: ""});
            }
        });
    };

    const removePreferredCourier = () => {
        stores.orderStore.removePreferredCourier({
            deliveryId: queueModalData?._id
        });
        setRecall(!recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setForceCourierValue(null);
        setQueueModalVisible(false);
        setAvailableCouriers(null);
    };

    const removeForceCourier = () => {
        stores.orderStore.removeForceCourier({
            deliveryId: queueModalData?._id
        });
        setRecall(!recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setForceCourierValue(null);
        setQueueModalVisible(false);
        setAvailableCouriers(null);
    };

    const updatePreferredCourier = () => {
        stores.orderStore.updatePreferredCourier({
            deliveryId: queueModalData?._id,
            courierId: preferredCourierValue
        });
        setRecall(!recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setQueueModalVisible(false);
        setForceCourierValue(null);
        setAvailableCouriers(null);
    };

    const updateForceCourier = () => {
        stores.orderStore.updateForceCourier({
            deliveryId: queueModalData?._id,
            forceCourierId: forceCourierValue
        });
        setRecall(!recallRef.current);
        setModalVisible(false);
        setPreferredCourierValue(null);
        setForceCourierValue(null);
        setQueueModalVisible(false);
        setAvailableCouriers(null);
    };

    return (
        <Wrapper>
            <SectionTabRow>
                <SectionTabButton
                    active={activeTab === "orders"}
                    onClick={() => setActiveTab("orders")}
                >
                    <SectionIcon src={DeliveryListIcon} />
                    Siparişlerim
                </SectionTabButton>
                <SectionTabButton active={activeTab === "map"} onClick={() => setActiveTab("map")}>
                    <SectionIcon src={MapIcon} />
                    Canlı Harita
                </SectionTabButton>
                <SectionTabButton
                    active={activeTab === "integrations"}
                    onClick={() => setActiveTab("integrations")}
                >
                    <SectionIcon src={IntegrationsIcon} />
                    Aktif Entegrasyonlar
                </SectionTabButton>
            </SectionTabRow>
            {activeTab === "orders" && (
                <>
                    <CustomTabRow>
                        <CustomTab
                            onClick={() => changeOrderType("current")}
                            active={orderType === "current"}
                        >
                            Aktif Siparişler
                        </CustomTab>
                        <CustomTab
                            onClick={() => changeOrderType("inQueue")}
                            active={orderType === "inQueue"}
                        >
                            Bekleyen Siparişler
                        </CustomTab>
                    </CustomTabRow>

                    <div style={{marginTop: "20px"}}>
                        <TableWrapper
                            rowKey="orderNumbers"
                            loading={loading}
                            columns={columns}
                            dataSource={deliveriesMapper()}
                            pagination={false}
                            scroll={{x: "max-content"}}
                            expandable={
                                window.innerWidth < 768
                                    ? {
                                          expandedRowRender: record => (
                                              <div>
                                                  <div>
                                                      <strong>Sipariş No:</strong>
                                                      <span>{record.orderNumbers}</span>
                                                  </div>
                                                  <div>
                                                      <strong>Tarih:</strong>
                                                      <span>{record.createdAt}</span>
                                                  </div>
                                                  <div>
                                                      <strong>Şube:</strong>
                                                      <span>{record.subcompanies}</span>
                                                  </div>
                                                  <div>
                                                      <strong>Kurye:</strong>
                                                      <span>{record.courier || "-"}</span>
                                                  </div>
                                              </div>
                                          ),
                                          expandRowByClick: true,
                                          showExpandColumn: true
                                      }
                                    : undefined
                            }
                        />
                        <CustomerOrderDetailModal
                            visible={customerOrderDetailModalVisible}
                            onCancel={() => {
                                setCustomerOrderDetailModalVisible(false);
                            }}
                            deliveryId={deliveryId}
                        />
                        <QueueModal
                            visible={queueModalVisible}
                            onCancel={() => {
                                setPreferredCourierValue(null);
                                setQueueModalVisible(false);
                                setAvailableCouriers(null);
                            }}
                            queueModalData={queueModalData}
                            preferredCourierValue={preferredCourierValue}
                            setPreferredCourierValue={setPreferredCourierValue}
                            forceCourierValue={forceCourierValue}
                            setForceCourierValue={setForceCourierValue}
                            availableCouriers={availableCouriers}
                            updatePreferredCourier={updatePreferredCourier}
                            removePreferredCourier={removePreferredCourier}
                            updateForceCourier={updateForceCourier}
                            removeForceCourier={removeForceCourier}
                            cancelDelivery={cancelDelivery}
                            setModalVisible={setModalVisible}
                            setModalData={setModalData}
                            setModalType={setModalType}
                            setText={setText}
                            setSubmit={setSubmit}
                            stores={stores}
                            data={deliveriesMapper()}
                            queueModalIndex={queueModalIndex}
                        />
                        <TextBoxFormModal
                            isVisible={modalVisible}
                            setVisible={() => setModalVisible(!modalVisible)}
                            okFunction={submit}
                            label={text.label}
                            title={text.title}
                            modalType={modalType}
                            modalData={modalData}
                            cancelFn={() => {
                                setModalType("");
                            }}
                        />
                    </div>

                    {/* <Row
                        justify="end"
                        style={{
                            width: "100%",
                            marginTop: "10px"
                        }}
                    >
                        <a href={`/musteri/siparislerim`} style={{fontWeight: "bold"}}>
                            <u>Tümünü Gör</u>
                        </a>
                    </Row> */}
                </>
            )}
            {activeTab === "map" && (
                <div>
                    <CustomerMap />
                </div>
            )}
            {activeTab === "integrations" && (
                <div>
                    <IntegrationsTab activeIntegrationUrls={activeIntegrationUrls} />
                </div>
            )}
            {/* <ManuelDeliveryButton
                isMobile={isMobile}
                onClick={() => history.push("/musteri/manuel-gonderi-olustur")}
            >
                <img src={ManuelDeliveryIcon} alt="manuel-delivery-icon" />
                Sipariş Oluştur
            </ManuelDeliveryButton> */}
        </Wrapper>
    );
};
